export default __webpack_public_path__ + "static/media/Talents.5f93e28a.svg";